import React from 'react';
import HeroBookDemoCta from './HeroBookDemoCta';
import HeroBrandLogo from './HeroBrandLogo';
import HeroTypewriterTitle from './HeroTypewriterTitle';
import '../hero/HeroSection.css';
import './SitesHeroSection.css';

const SitesHeroSection: React.FC = () => (
  <section className="hero">
    <div className="hero-bg" aria-hidden="true">
      <img src="/images/hero_lummo.png" alt="" loading="eager" className="hero-bg-img" />
      <div className="hero-vignette" />
    </div>
    <div className="hero-container">
      <div className="hero-inner">
        <HeroTypewriterTitle text="Sites: Always Ready for the Next Trial" />
        <p className="hero-subtitle">Less admin, cleaner docs, and matched studies that fit your capacity — Lummo puts your site at the center of LATAM clinical research.</p>
        <HeroBookDemoCta />
        <HeroBrandLogo />
      </div>
    </div>
    <div className="scroll-indicator" aria-hidden="true">
      <span className="scroll-dot" />
    </div>
  </section>
);
export default SitesHeroSection;
